import React from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import options from '../../../../helpers/ContentFulOptions';
import { ParsedContentWrapper } from './styles/RichText.styles';


type TextAlignProps =
  | 'start'
  | 'end'
  | 'left'
  | 'right'
  | 'center'
  | 'justify'
  | 'match-parent';

export type RichTextProps = {
  kind?: 'richText';
  id?: string;
  text?: {
    raw: string;
    references?: [
      {
        contentful_id: string;
        gatsbyImageData: IGatsbyImageData;
        description: string;
        file: {
          url: string;
        };
      }
    ];
  };
  rawRichText?: string;
  color?: string;
  textAlign?: TextAlignProps;
  className?: string;
  __typename?: string;
};

const RichText = (props: RichTextProps) => {
  const { text, rawRichText, color, textAlign, className } = props;

  function combineAssetReferencesToRichText(text: RichTextProps['text']) {
    if (!text) {
      return;
    }
    const { raw, references } = text;
    const imagesPattern = /.*(png|jpg|jpeg|gif|svg)/i;
    const rawParsed = JSON.parse(raw);
    rawParsed.content.forEach((item: any, index: number) => {
      if (item.nodeType === 'embedded-asset-block') {
        const contentful_id = item.data.target.sys.id;
        if (references) {
          references.some(ref => {
            const { description, gatsbyImageData } = ref;
            const isFound = ref.contentful_id === contentful_id;
            if (isFound && imagesPattern.test(ref.file.url)) {
              rawParsed.content[index].data.target.sys.gatsbyImageData =
                gatsbyImageData;
              rawParsed.content[index].data.target.sys.description =
                description;
            }
            return isFound;
          });
        } else {
          const errorMsg = `error in RawText`;
          throw new Error(errorMsg);
        }
      }
    });
    return rawParsed;
  }

  let parsedRaw;
  if (text && text.references) {
    parsedRaw = documentToReactComponents(
      combineAssetReferencesToRichText(text),
      options
    );
  } else {
    if (rawRichText === undefined || rawRichText === '') return null;
    parsedRaw = documentToReactComponents(JSON.parse(rawRichText), options);
  }

  function convertTextAlignmentToLogical(): TextAlignProps | undefined {
    switch (textAlign) {
      case 'left':
        return 'start';
      case 'right':
        return 'end';
      default:
        return textAlign;
    }
  }

  return (
    <ParsedContentWrapper
      color={color}
      textAlign={convertTextAlignmentToLogical()}
      className={className}
    >
      {parsedRaw}
    </ParsedContentWrapper>
  );
};

export default RichText;
